import { Link, useLocation } from 'react-router-dom';

export default function Sidebar({ isOpen, onClose, isMobile }) {
  const location = useLocation();
  const userRole = localStorage.getItem('role');

  const navItems = [
    {
      path: '/admin/dashboard',
      icon: 'fas fa-chart-bar',
      label: 'داشبۆردی سەرەکی'
    },
    {
      path: '/admin/availability',
      icon: 'fas fa-users',
      label: 'هاتوو و نەهاتوو'
    },
    {
      path: '/admin/supervisors',
      icon: 'fas fa-user-shield',
      label: 'بەکارهێنەران'
    },
    {
      path: '/admin/bases',
      icon: 'fas fa-building',
      label: 'بنکەکان'
    },
    {
      path: '/admin/importers',
      icon: 'fas fa-file-import',
      label: 'داغلکردنی داتا'
    }
    ,
    {
      path: '/admin/export',
      icon: 'fas fa-file-export',
      label: 'Export Data'
    }
    ,
  ];

  // ✅ Conditionally add the log menu item if not superadmin
  if (userRole === 'superadmin') {
    navItems.push({
      path: '/admin/log',
      icon: 'fas fa-clipboard-list',
      label: 'چالاکی بەکارهێنەر'
    });
  }

  // ✅ Check if current path is active
  const isActive = (itemPath) => {
    const currentPath = location.pathname;

    if (itemPath === '/admin/dashboard') {
      return (
        currentPath === '/admin/dashboard' ||
        currentPath === '/admin' ||
        currentPath === '/admin/' ||
        currentPath.startsWith('/admin/dashboard')
      );
    }

    return currentPath === itemPath || currentPath.startsWith(itemPath + '/');
  };

  const handleLinkClick = () => {
    if (isMobile && onClose) {
      onClose();
    }
  };

  return (
    <aside className={`sidebar ${isMobile && isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <h2>داشبۆردی بەڕێوەبەر</h2>
        {isMobile && (
          <button 
            className="sidebar-close-btn"
            onClick={onClose}
            aria-label="Close menu"
          >
            <i className="fas fa-times"></i>
          </button>
        )}
      </div>

      <nav className="sidebar-nav">
        <ul>
          {navItems.map((item) => (
            <li 
              key={item.path} 
              className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
            >
              <Link 
                to={item.path} 
                className="nav-link"
                onClick={handleLinkClick}
              >
                <i className={`${item.icon} sidebar-icon`}></i>
                <span>{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
